import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function QueenCreekPage() {
  return <LocationPageTemplate city="Queen Creek" cityShort="Queen Creek" slug="queen-creek" data-id="element-1019" />;
}